module.exports = __webpack_public_path__ + "static/media/school_default.4a4ffc88.svg";